<template>
  <div>
    <v-row class="pa-0 ma-0" v-if="win === 1">
      <v-col class="ma-0 pa-0" cols="6" style="padding-left: 150px !important">
        <div style="height: 350px !important"></div>
        <p style="line-height: 30px; font-size: 50px" class="font-weight-bold">
          Bienvenido a la
        </p>
        <p
          style="line-height: 50px; color: #25558f; font-size: 50px"
          class="text-capitalize font-weight-black"
        >
          VENTANILLA DE ATENCIÓN <br />
          A TRÁMITES
        </p>
        <p
          style="line-height: 30px; font-size: 30px"
          class="font-weight-medium pt-10"
        >
          El objetivo es atender los temas referentes a <br />
          trámites y servicios universitarios.

        </p>
        <v-img
          style="margin-top: 80px"
          width="600"
          :src="require('../assets/m.svg')"
        ></v-img>
      </v-col>
      <v-col class="ma-0 pa-0" cols="6">
        <div style="height: 130px !important"></div>
        <v-card
          class="text-center"
          style="margin-left: 100px; margin-right: 150px"
          height="650"
          tile
          elevation="3"
          color="#f9f9f9"
        >
          <v-container fill-height>
            <v-row align="center" justify="center" class="text-center">
              <v-col cols="12" sm="5" align="center" justify="center">
                <v-img width="230" :src="require('../assets/u.svg')"></v-img>
                <v-select
                  class="pt-10"
                  height="70"
                  style="border-radius: calc(1em + 1vw) !important"
                  v-model="formulario.tipoRel"
                  :items="tipoRelacion"
                  label="Selecciona tu perfil"
                  solo
                  item-text="desC_RELACION_UG"
                  item-value="iD_RELACION_UG"
                >
                </v-select>
                <v-btn
                  style="border-radius: calc(1em + 1vw) !important"
                  color="primary"
                  @click="seleccionRel()"
                >
                  Siguiente
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <div style="height: 130px !important"></div>

    <v-row class="pa-0 ma-0" align="center" justify="center" v-if="win === 2">
      <v-col class="ma-0 pa-0" cols="4">
        <v-card
          class="text-center"
          height="860"
          tile
          elevation="3"
          color="#f9f9f9"
        >
          <v-container fill-height>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="5" align="center" justify="center">
                <v-img width="230" :src="require('../assets/u.svg')"></v-img>
                <v-select
                  class="pt-10"
                  height="70"
                  style="border-radius: calc(1em + 1vw) !important"
                  v-model="formulario.tipoRel"
                  :items="tipoRelacion"
                  label="Selecciona tu perfil"
                  solo
                  item-text="desC_RELACION_UG"
                  item-value="iD_RELACION_UG"
                >
                </v-select>
                <v-btn
                  style="border-radius: calc(1em + 1vw) !important"
                  color="primary"
                  @click="seleccionRel()"
                >
                  Siguiente
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>

      <v-col class="ma-0 pa-0" cols="6">
        <v-card tile height="860">
          <v-card-title
            style="font-family: Raleway !important"
            class="title primary white--text pa-10"
            primary-title
          >
            <p
              style="line-height: 25px; font-size: 25px"
              class="font-weight-bold"
            >
              Nuevo Reporte {{ relacion }}
            </p>
            <v-row class="pa-0 ma-0">
              <v-col cols="6" class="pa-0 ma-0 pr-3">
                <v-text-field
                  height="50"
                  dark
                  v-model="formulario.nombre"
                  label="Nombre"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="pa-0 ma-0 pr-3">
                <v-text-field
                  height="50"
                  dark
                  v-model="formulario.apaterno"
                  label="Primer Apellido"
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="pa-0 ma-0">
                <v-text-field
                  height="50"
                  dark
                  v-model="formulario.amaterno"
                  label="Segundo Apellido"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 pr-3">
                <v-text-field  v-if="ban_ocultar_nuanue"
                  height="50"
                  dark
                  v-model="formulario.nuaNue"
                  :label="iduser"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0">
                <v-text-field
                  height="50"
                  dark
                  :rules="[rules.email]"
                  type="email"
                  v-model="formulario.correo"
                  label="Correo Electronico"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>

        <v-row class="px-3" style="margin-bottom: -20px !important">
            <v-col cols="12" class="pa-0 ma-0">
              <v-alert tile elevation="0" color="#25558F" dark>
                No olvides colocar tu entidad de adscripción (División o ENMS), sin ella no podremos atender tu solicitud. Si usted es madre o padre de familia colocar la información de su hijo o hija.        

                 </v-alert>
            </v-col>
          </v-row>

          <v-row class="px-3" style="margin-top: 0px !important">
              <v-col cols="6" class="pa-0 ma-0">
              <v-card tile elevation="0" color="#25558F">
                <v-select
                  height="50"
                  class="px-10 py-4"
                  dark
                  @change="llamarDivision()"
                  v-model="formulario.Campus"
                  :items="campus"
                  label="Campus/Colegio Nivel Medio Superior"
                  item-text="nombre_Unidad"
                  item-value="id_Unidad_PK"
                ></v-select>
              </v-card>
            </v-col>
            <v-col cols="6" class="pa-0 ma-0">
              <v-card tile elevation="0" color="#2E63A3">
                <v-select
                  height="50"
                  class="px-10 py-4"
                  dark
                  v-model="formulario.Division"
                  :items="division"
                  label="División/Escuela Nivel Medio Superior"
                  item-text="nombre_Unidad"
                  item-value="id_Unidad_PK"
                ></v-select>
              </v-card>
            </v-col>
          </v-row>

          <v-card-text
            class="pt-5 pb-0"
            style="color: #002d53; font-size: 16px; line-height: 22px"
          >
            <v-row class="pa-0 ma-0">
              <!-- <v-col cols="4" class="pa-0 ma-0"> </v-col> -->

              <v-col cols="12" class="pa-6 pt-8 pb-0 ma-0" style="margin-top: -15px !important">
                      <v-alert
           border="top"
      colored-border
      type="info"
      elevation="2"
      >
                Favor de describir a detalle el trámite o servicio a atender, incluir si es solicitud de información, seguimiento al trámite, asesoría, etc., su entidad de adscripción y si ha contado con una atención previa definir dónde se brindó. 
                </v-alert>

                <v-textarea
                  rows="6"
                  v-model="formulario.mensaje"
                  label="Descripción del trámite o servicio a atender"
                  outlined
                ></v-textarea>
              </v-col>

              <v-col cols="12" class="pa-0 ma-0 pb-3 px-5">
                <v-checkbox
                  style="
                    margin-top: 0px !important;
                    padding-top: 0px !important;
                  "
                  v-model="formulario.avisoPriv"
                  color="primary"
                >
                  <template v-slot:label>
                    <div style="line-height: 10px; font-size: 11px">
                      "Manifiesto mi consentimiento para el tratamiento de los
                      datos personales recabados en el presente formato, los
                      cuales serán protegidos, incorporados y tratados en la
                      base del Buzón de quejas, sugerencias, comentarios y
                      felicitaciones de la Universidad de Guanajuato, con
                      fundamento en el
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="http://www.buzon.ugto.mx/buzon_captura/uploads/AVISO_DE_PRIVACIDAD.pdf"
                            @click.stop
                            v-on="on"
                          >
                            Aviso de Privacidad Integral (Descargar)"
                          </a>
                        </template>
                        Ir al Aviso Completo
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text class="text-end pt-0">
            <v-btn
              style="border-radius: calc(1em + 1vw) !important"
              class="mr-3"
              dark
              color="red"
              @click="cancelar()"
            >
              Anterior
            </v-btn>
            <v-btn
              class="mr-6"
              style="border-radius: calc(1em + 1vw) !important"
              color="primary"
              @click="guardarReporte()"
            >
              Enviar
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="esNotificado"
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">From the bottom</v-btn>
        </template> -->
      <template>
        <v-card>
          <v-toolbar class="pl-3" color="primary" dark
            >Reporte Guardado</v-toolbar
          >
          <v-card-text>
            <div class="text-h6 pt-5 my-3 text-center">
              Su reporte ha sido guardado y notificado con exito, pronto será
              atendido.
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end px-2">
            <v-btn color="primary" @click="$store.commit('quitarNoti', true)"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-snackbar v-model="alerta" color="primary">
      {{ textAlerta }}

      <template v-slot:action="{ attrs }">
        <v-btn text dark v-bind="attrs" @click="alerta = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      rules: {
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "email invalido.";
        },
      },
      relacion: "",
      iduser: "",
      alerta: false,
      textAlerta: "",
      esDiv: false,
      ban_ocultar_nuanue : true,
      formulario: {
        tipoRel: 0,
        tipoSel: 0,
        nuaNue: "",
        nombre: "",
        apaterno: "",
        amaterno: "",
        correo: "",
        Campus: 0,
        Division: 0,
        mensaje: "",
        avisoPriv: false,
      },
      win: 1,
      usuario: [],
    };
  },
  computed: {
    ...mapState([
      "esNotificado",
      "empleadoDatos",
      "panelSel",
      "tipoMensaje",
      "tipoRelacion",
      "campus",
      "division"
    ]),
  },
  async created() {},
  mounted() {
    this.obtenerTipoMensaje();
    this.obtenerRelacion();
    this.obtenerCampus();
  },
  methods: {
    ...mapActions([
      "obtenerEmpleado",
      "obtenerTipoMensaje",
      "obtenerRelacion",
      "obtenerCampus",
      "obtenerDivision",
      "guardaReporte",
    ]),

    Guardar() {
      console.log("Datos", this.formulario);
    },

    guardarReporte() {
      if (this.formulario.avisoPriv !== false) {
        if (
          this.formulario.tipoRel !== 0 && 
          this.formulario.nuaNue !== "" &&
          this.formulario.nombre !== "" &&
          this.formulario.apaterno !== "" &&
          this.formulario.amaterno !== "" &&
          this.formulario.correo !== "" &&
          this.formulario.Campus !== 0 &&
          this.formulario.Division !== 0 &&
          this.formulario.mensaje !== ""
        ) {
          let nua = 0;
          let nue = 0;
          if (this.formulario.nuaNue.length === 5) {
            nue = this.formulario.nuaNue;
          }
          if (this.formulario.nuaNue.length === 6) {
            nua = this.formulario.nuaNue;
          }

          let temp = {
            NOMBRE: this.formulario.nombre,
            APELLIDO_PATERNO: this.formulario.apaterno,
            APELLIDO_MATERNO: this.formulario.amaterno,
            CORREO_ELECTRONICO: this.formulario.correo,
            ID_CAMPUS: this.formulario.Campus,
            ID_DIVISION: this.formulario.Division,
            MENSAJE: this.formulario.mensaje,
            ID_RELACION_UG: this.formulario.tipoRel,
            MANIFIESTO: true,
            nua: nua,
            id_empleado: nue,
          };
          // console.log("Datos", this.formulario);
          this.guardaReporte(temp);
          this.win = 1;
          this.formulario = [];
        } else {
          this.alerta = true;
          this.textAlerta = "Llene todos los campos..";
        }
      } else {
        this.alerta = true;
        this.textAlerta = "Aviso de Privacidad no seleccionado";
      }
    },

    cancelar() {
      this.win = 1;
      this.formulario = {
        tipoRel: 0,
        tipoSel: 0,
        nuaNue: "",
        nombre: "",
        apaterno: "",
        amaterno: "",
        correo: "",
        Campus: 0,
        Division: 0,
        mensaje: "",
        avisoPriv: false,
      };
    },

    seleccionRel() {
      this.ban_ocultar_nuanue = true;  

      this.tipoRelacion.map((element) => {
        if (element.iD_RELACION_UG === this.formulario.tipoRel) {
          this.relacion = element.desC_RELACION_UG;
        }
      });

      if (this.formulario.tipoRel !== 0) {
        this.win = 2;
      } else {
        // this.win = 2;
        this.alerta = true;
        this.textAlerta = "Seleccione el tipo de Relación para continuar..";
      }

      if (this.relacion === "Académico" || this.relacion === "Administrativo") {
        this.iduser = "Nue";
      }
      if (this.relacion === "Alumno" || this.relacion === "Egresado" || this.relacion === "Padre o madre de familia") {
        this.iduser = "Nua";
        this.formulario.nuaNue="";
      }

      if ( this.relacion === "Público en General") {
        this.iduser = "";
        this.formulario.nuaNue=" ";    
        this.ban_ocultar_nuanue = false;    
      }

      console.log(this.relacion);
    },

    llamarDivision() {
      console.log(this.formulario.Campus);
      this.obtenerDivision(this.formulario.Campus);
      //   this.esDiv = true;
    },
  },
};
</script>

<style>
#app {
  background: url("../assets/o.svg") no-repeat top right !important;
  background-size: 1000px !important;
  margin-right: -60px;
}

.v-input__slot {
  font-family: "Raleway";
  height: 70px;
  text-align: center;
}
</style>
